module.exports = __webpack_public_path__ + "static/media/plus.245219db.svg";